import { YouTubeIdFromUrl } from '../../../ts/helper';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="atom-youtube-player"]';

/**
 * Friendation component
 */
export const atomYouTubePlayer = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /** YouTube Video URL */
    const youTubeUrl = component.getAttribute('data-url');
    if (!youTubeUrl) {
      console.error('Missing attribute value data-url on component', component);
      return;
    }

    /** YouTube Video ID */
    const youTubeId = YouTubeIdFromUrl(youTubeUrl);
    if (!youTubeId) {
      console.error('Could not read YouTube ID from URL', youTubeUrl);
      return;
    }

    /** The poster with the thumbnail */
    const poster: HTMLElement = component.querySelector('.poster');
    if (!poster) {
      console.error('Missing element poster on component', component);
      return;
    }

    /** Clicking the play button will set the correct source for the {@link iframe} and remove the {@link poster} */
    const playButton = <HTMLButtonElement>(
      component.querySelector('button.poster-overlay')
    );
    if (!playButton) {
      console.error('Missing element playButton on component', component);
      return;
    }

    const handlePoster = () => {
      /**
       * Callback for click on {@link playButton}. Will set the correct attributes on the {@link iframe} and remove the {@link poster}.
       */
      const loadVideo = () => {
        /** YouTube player */
        const iframe = component.querySelector('iframe');
        if (!iframe) {
          console.error('Could not find iframe in component', component);
          return;
        }

        /** Replace the placeholder with the {@link youTubeId} */
        iframe.src = iframe.src.replace('%id%', youTubeId);

        /** Remove the poster */
        poster.remove();

        // The video will start automatically, because we set the autoplay option in twig
      };

      playButton.addEventListener('click', loadVideo.bind(this));
    };

    handlePoster();
  });
};
